import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Badge,
  Button,
  Card,
  Checkbox,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Pagination,
  Spinner,
  Table,
} from "flowbite-react";
import { FaArrowsLeftRight } from "react-icons/fa6";
import axios from "../../config/axiosInstance";
import { useQuery } from "react-query";
import {
  ADMIN,
  CATEGORIES,
  COMPANY,
  REPORTS,
  USERS,
} from "../../config/apiConfig";
import { formatToReal, isOlderThan30Days } from "../../utils/utils";
import { IoMdSearch } from "react-icons/io";
import EmptyTable from "./EmptyTable";
import {
  MdOutlineAttachMoney,
  MdOutlinePageview,
  MdPageview,
} from "react-icons/md";
import { BsFillBarChartFill } from "react-icons/bs";
import DrawerLoading from "../DrawerLoading";
import TableLoading from "../TableLoading";
import { useApplication } from "../../contexts/ApplicationContext";
import CustomCreditQueryReview from "../queries/CustomCreditQueryReview";
import CustomVehicleQueryReview from "../queries/CustomVehicleQueryReview";
import { CgDetailsMore } from "react-icons/cg";
import { Tooltip } from "react-tooltip";
import { useReactToPrint } from "react-to-print";
import { FaArrowRight, FaFilter, FaMoneyBillWave } from "react-icons/fa";
import { LuFilter, LuFilterX } from "react-icons/lu";
import AutoCompleteInput from "../inputs/Autocomplete";
import CustomCadastralQueryReview from "../queries/CustomCadastralQueryReview";

const ReportTable = () => {
  const { user, userPermission } = useApplication();
  const [activeTab, setActiveTab] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPriceSum, setTotalPriceSum] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const onPageChange = (page) => setCurrentPage(page);
  const [searchName, setSearchName] = useState("");
  const [nameParam, setNameParam] = useState("");
  const [selectedQueries, setSelectedQueries] = useState([]);
  const [listCategoryQueries, setListCategoryQueries] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [dataQuery, setDataQuery] = useState(null);
  const [selectedQuery, setSelectedQuery] = useState(0);
  const [selectedQueryReview, setSelectedQueryReview] = useState(null);
  const printRef = useRef();
  const reactToPrintFn = useReactToPrint({ contentRef: printRef });
  const [showFilters, setShowFilters] = useState(true);
  const [renderFilters, setRenderFilters] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({
    label: "Todos os produtos",
    value: 0,
  });
  const [selectedUserId, setSelectedUserId] = useState("");

  useEffect(() => {
    if (userPermission === "SELLER" || userPermission === "USER") {
      setSelectedUserId(user?.id);
    }
  }, [userPermission]);

  useEffect(() => {
    if (showFilters) {
      setRenderFilters(true); // mostra o conteúdo imediatamente
    } else {
      // espera a animação terminar antes de esconder
      const timeout = setTimeout(() => setRenderFilters(false), 500); // mesmo tempo da transition
      return () => clearTimeout(timeout);
    }
  }, [showFilters]);

  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const {
    isLoading: isLoadingQueryPermissions,
    error: errorQueryPermissions,
    data: userQueryPermissions,
  } = useQuery(["userQueryPermissions"], async () => {
    const { data: items } = await axios.get(
      `${USERS.GET_USER_QUERY_PERMISSIONS}`
    );

    return items?.data?.map((query) => query.id);
  });

  const {
    isLoading: isLoadingUsers,
    error: errorUsers,
    data: users,
  } = useQuery(["users"], async () => {
    const { data: items } = await axios.get(
      `${USERS.GET_USERS}?itemsPerPage=-1`
    );

    return items.data.data;
  });

  const {
    isLoading: isLoadingCategories,
    error: errorCategories,
    data: categories,
  } = useQuery(["categories", currentPage], async () => {
    const { data } = await axios.get(`${CATEGORIES.GET_ALL}`);

    return data.data.data;
  });

  const {
    isLoading: isLoadingQueries,
    error: errorQueries,
    data: listQueries,
  } = useQuery(["listQueries"], async () => {
    try {
      const { data } = await axios.get(`${COMPANY.GET_PERMISSION_QUERIES}`);

      if (!data.data) {
        throw new Error("Erro ao buscar produtos");
      }

      let customers = data.data.map((customer) => ({
        label: customer.name,
        value: customer.QueryId,
      }));

      customers = [{ label: "Todos os produtos", value: 0 }, ...customers];

      return customers;
    } catch (error) {
      throw new Error(`Erro ao buscar produtos: ${error.message}`);
    }
  });

  const {
    isLoading: isLoadingReportQueries,
    error: errorListReportQueries,
    data: listReportQueries,
  } = useQuery(
    [
      "listReportQueries",
      startDate,
      endDate,
      currentPage,
      selectedQueries,
      selectedStatuses,
      nameParam,
      selectedProduct,
      selectedUserId,
    ],
    async () => {
      const { data } = await axios.get(
        `${REPORTS.GET_COMPANY_QUERIES_HISTORY}?startDate=${startDate}&endDate=${endDate}&page=${currentPage}&status=${selectedStatuses}&search=${nameParam}&queries=${selectedProduct?.value}&userId=${selectedUserId}`
      );

      setTotalPages(data.data.totalPages);
      setTotalPriceSum(data.data.totalPriceSum);
      setTotalCount(data.data.totalCount);

      return data.data.data;
    }
  );

  const {
    isLoading: isLoadingReportSimplifiedQueries,
    error: errorListReportSimplifiedQueries,
    data: listReportSimplifiedQueries,
  } = useQuery(
    [
      "listReportSimplifiedQueries",

      startDate,
      endDate,
      currentPage,
      selectedQueries,
      selectedStatuses,
      selectedProduct,
      selectedUserId,
    ],
    async () => {
      const { data } = await axios.get(
        `${REPORTS.GET_COMPANY_QUERIES_HISTORY_SIMPLIFIED}?startDate=${startDate}&endDate=${endDate}&page=${currentPage}&status=${selectedStatuses}&isModular=false&queries=${selectedProduct?.value}&userId=${selectedUserId}`
      );

      setTotalPages(data.data.totalPages);
      setTotalPriceSum(data.data.totalSumPrice || 0);
      setTotalCount(data.data.totalSumCount);

      return data.data.data;
    },
    {
      enabled: activeTab === 1,
    }
  );

  const handleCheckboxChange = (status, setState) => {
    setState((prev) =>
      prev.includes(status)
        ? prev.filter((item) => item !== status)
        : [...prev, status]
    );
  };

  const handleSearchName = (e) => {
    e.preventDefault();
    setNameParam(searchName);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [
    activeTab,
    startDate,
    endDate,
    selectedProduct,
    selectedStatuses,
    selectedUserId,
  ]);

  useEffect(() => {
    setListCategoryQueries(() =>
      categories?.map((category) => {
        return {
          ...category,
          Queries: category?.Queries?.filter((query) =>
            userQueryPermissions?.includes(query.id)
          ),
        };
      })
    );
  }, [userQueryPermissions, categories]);

  // const handleDownloadPDF = async (index, fileName) => {
  //   setLoadingDownload(true);
  //   setActiveIndexLoading(index);

  //   try {
  //     const dataFile = await axios.get(
  //       `/query/download/pdf?fileName=${fileName}`
  //     );
  //     const link = document.createElement("a");
  //     link.href = dataFile.data.fileUrl;
  //     link.setAttribute("download", fileName);
  //     link.setAttribute("target", "_blank");
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   } catch (error) {
  //     console.error("Erro ao iniciar o download:", error);
  //   } finally {
  //     setLoadingDownload(false);
  //     setActiveIndexLoading(null);
  //   }
  // };

  return (
    <div className="relative">
      <div className="flex justify-between items-center mb-2">
        <Button
          size="xs"
          onClick={() => setShowFilters((prev) => !prev)}
          className="primary text-white transition-all duration-300"
        >
          <div className="flex items-center gap-2 transition-all duration-300">
            <span>{showFilters ? "Esconder filtros" : "Mostrar filtros"}</span>
            <span className={`transition-transform duration-300 `}>
              {!showFilters ? <LuFilter /> : <LuFilterX />}
            </span>
          </div>
        </Button>
      </div>
      <div className="flex flex-col gap-4">
        {showFilters && (
          <div className="transition-all duration-500 ease-in-out bg-white border border-gray-200 rounded-2xl shadow-md px-6 py-5">
            {(isLoadingCategories || isLoadingQueryPermissions) && (
              <DrawerLoading />
            )}

            <div className="flex grid grid-cols-1 md:grid-cols-3 gap-6 items-start lg:items-end justify-between">
              {/* Produto */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Produto
                </label>
                <div className="h-11">
                  <AutoCompleteInput
                    options={listQueries}
                    label=""
                    onChange={(product) => setSelectedProduct(product)}
                    value={selectedProduct?.value}
                    isLoading={isLoadingQueries}
                    className="h-full"
                  />
                </div>
                {errorQueries && (
                  <Alert color="failure" className="mt-2">
                    Ocorreu um erro ao buscar clientes
                  </Alert>
                )}
              </div>
              {/* Período */}
              <div className="flex flex-col md:col-span-2">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Período
                </label>
                <div className="flex gap-2 items-center h-11">
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                      if (moment(e.target.value).isAfter(moment(endDate))) {
                        setEndDate(e.target.value);
                      }
                    }}
                    className="w-full h-full bg-gray-50 border border-gray-300 text-sm rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <span className="text-sm text-gray-500">até</span>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    min={startDate}
                    className="w-full h-full bg-gray-50 border border-gray-300 text-sm rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
              </div>

              {/* Status */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700 mb-1">
                  Status da Consulta
                </label>
                <div className="flex gap-2 h-11">
                  <button
                    type="button"
                    onClick={() => handleCheckboxChange(1, setSelectedStatuses)}
                    className={`h-full px-4 rounded-lg text-sm font-medium border transition w-full ${
                      selectedStatuses.includes(1)
                        ? "bg-green-100 text-green-700 border-green-300"
                        : "bg-white text-gray-600 border-gray-300 hover:bg-gray-50"
                    }`}
                  >
                    ✅ Sucesso
                  </button>
                  <button
                    type="button"
                    onClick={() => handleCheckboxChange(0, setSelectedStatuses)}
                    className={`h-full px-4 rounded-lg text-sm font-medium border transition w-full ${
                      selectedStatuses.includes(0)
                        ? "bg-red-100 text-red-700 border-red-300"
                        : "bg-white text-gray-600 border-gray-300 hover:bg-gray-50"
                    }`}
                  >
                    ❌ Falha
                  </button>
                </div>
              </div>
              {userPermission === "ADMIN" ||
                (userPermission === "POWER_USER" && (
                  <div className="w-full">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Usuário
                    </label>
                    <div className="flex gap-2">
                      <select
                        value={selectedUserId}
                        onChange={(e) => setSelectedUserId(e.target.value)}
                        className="w-full bg-gray-50 border border-gray-300 text-sm rounded-lg px-3 py-2.5 focus:ring-blue-500 focus:border-blue-500"
                      >
                        <option value="">Todos os usuários</option>
                        {(users || []).map((u) => (
                          <option key={u.id} value={u.id}>
                            {u.name} {u.email ? `— ${u.email}` : ""}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}

        <div className="flex-1 overflow-x-scroll">
          <div className="title-syncx mt-3 mb-4">Resultado da busca</div>
          {startDate && endDate && (
            <div className="italic text-sm mb-2 flex items-center gap-2">
              Informações baseadas no período de{" "}
              <Badge className="w-fit">
                {moment(startDate).format("DD/MM/yyyy")}
              </Badge>{" "}
              até{" "}
              <Badge className="w-fit">
                {" "}
                {moment(endDate).format("DD/MM/yyyy")}
              </Badge>
            </div>
          )}

          <div className="overflow-x-auto mt-4 mb-4">
            <div className="flex gap-4 min-w-[900px] pb-2">
              {/* Valor Total */}
              {/* <div className="min-w-[260px] flex-1 rounded-2xl p-4 shadow-md text-white bg-gradient-to-br from-[#1E429F] to-[#4F46E5] relative">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm opacity-90">Valor Total</p>
                    <h2 className="text-2xl font-bold mt-1">
                      {!isLoadingReportQueries ? (
                        formatToReal(totalPriceSum)
                      ) : (
                        <div className="animate-pulse w-32 h-6 bg-white/30 rounded" />
                      )}
                    </h2>
                  </div>
                  <MdOutlineAttachMoney className="text-white text-4xl opacity-20" />
                </div>
              </div> */}

              {/* Total de Consultas */}
              <div className="min-w-[260px] flex-1 rounded-2xl p-4 shadow-md text-white bg-gradient-to-br from-[#0F766E] to-[#14B8A6] relative">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm opacity-90">Total de Consultas</p>
                    <h2 className="text-2xl font-bold mt-1">
                      {!isLoadingReportQueries ? (
                        totalCount
                      ) : (
                        <div className="animate-pulse w-24 h-6 bg-white/30 rounded" />
                      )}
                    </h2>
                  </div>
                  <BsFillBarChartFill className="text-white text-4xl opacity-20" />
                </div>
              </div>

              {/* VCM */}
              {user?.Company?.typePayment === "POS" && (
                <div className="min-w-[260px] flex-1 rounded-2xl p-4 shadow-md text-white bg-gradient-to-br from-[#B45309] to-[#F59E0B] relative">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm opacity-90">
                        Consumação Mínima (VCM)
                      </p>
                      <h2 className="text-2xl font-bold mt-1">
                        {user?.Company?.vcm
                          ? formatToReal(user?.Company?.vcm)
                          : "-"}
                      </h2>
                    </div>
                    <MdOutlineAttachMoney className="text-white text-4xl opacity-20" />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="mb-4 flex justify-end items-center gap-2">
            <div className="text-xs font-semibold">Visualizar relatório:</div>
            <ul className="text-sm rounded-md border border-gray-300 flex">
              <li
                className={`py-2 px-4 rounded-md cursor-pointer ${
                  activeTab === 0
                    ? `bg-primary text-white font-semibold shadow-md`
                    : `bg-white`
                }`}
                onClick={() => setActiveTab(0)}
              >
                Detalhado
              </li>
              <li
                className={`py-2 px-4 rounded-md cursor-pointer ${
                  activeTab === 1
                    ? `bg-primary text-white font-semibold shadow-md`
                    : `bg-white`
                }`}
                onClick={() => setActiveTab(1)}
              >
                Simplificado
              </li>
            </ul>
          </div>
          {activeTab === 0 && (
            <form
              className="flex gap-1 mt-0 w-full pl-3 pr-2 py-2 md:py-1 rounded-md shadow-sm bg-gray-300"
              onSubmit={handleSearchName}
            >
              <input
                type="text"
                placeholder="Busque por parâmetro da consulta..."
                className="border-0 py-1 text-sm mt-1 focus:outline-none focus:ring-0 focus:border-gray-300 px-0 w-full bg-gray-300 placeholder:text-gray-700"
                onChange={(e) => setSearchName(e.target.value)}
                value={searchName}
              />
              <Button
                size="sm"
                className="flex items-center bg-secondary w-20"
                type="submit"
              >
                <IoMdSearch />
              </Button>
            </form>
          )}

          <small
            className="gap-2 items-center mt-5 mb-1 flex md:hidden justify-center"
            style={{ fontSize: 10 }}
          >
            <span>
              Deslize para o lado para visualizar todas as informações
            </span>{" "}
            <FaArrowsLeftRight />
          </small>
          {activeTab === 0 ? (
            <>
              {listReportQueries?.length > 0 || isLoadingReportQueries ? (
                <div className="overflow-x-auto shadow-md rounded-lg mt-0 md:mt-5">
                  <Table striped style={{ fontSize: "13px" }}>
                    <Table.Head>
                      <Table.HeadCell className="text-center bg-gray-300">
                        Data
                      </Table.HeadCell>
                      <Table.HeadCell className="bg-gray-300">
                        Consulta
                      </Table.HeadCell>
                      {user?.Company?.showPriceQuery && (
                        <Table.HeadCell className="text-center bg-gray-300">
                          Valor
                        </Table.HeadCell>
                      )}
                      <Table.HeadCell className="text-center bg-gray-300">
                        Usuário
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-gray-300">
                        Status
                      </Table.HeadCell>
                      <Table.HeadCell className="text-center bg-gray-300">
                        Ações
                      </Table.HeadCell>
                    </Table.Head>

                    <Table.Body className="divide-y">
                      {!isLoadingReportQueries ? (
                        <>
                          {listReportQueries?.length > 0 ? (
                            listReportQueries.map((query, index) => (
                              <Table.Row
                                key={index}
                                className="bg-white hover:bg-blue-50 transition-colors text-sm text-gray-800"
                              >
                                {/* Data */}
                                <Table.Cell className="text-center py-3 px-4 font-medium text-sm text-gray-700 leading-tight">
                                  <div className="text-gray-900 font-semibold">
                                    {moment(query.createdAt).format(
                                      "DD/MM/yyyy"
                                    )}
                                  </div>
                                  <div className="text-xs text-gray-500">
                                    {moment(query.createdAt).format("HH:mm")}h
                                  </div>
                                </Table.Cell>

                                {/* Nome da consulta + parâmetro */}
                                <Table.Cell className="py-2 px-4">
                                  <div className="font-semibold text-gray-900">
                                    {query.queryName}{" "}
                                    {query?.hasIA ? (
                                      <span className="inline-block ml-1 text-blue-600">
                                        {" "}
                                        + IA
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  <div className="text-xs text-gray-500">
                                    Parâmetro: {query.parameter}
                                  </div>
                                </Table.Cell>

                                {user?.Company?.showPriceQuery && (
                                  <Table.Cell className="text-center py-3 px-4">
                                    <span className="inline-flex items-center gap-1 bg-gray-100 text-gray-800 text-xs font-semibold px-3 py-1 rounded-full shadow-sm">
                                      <FaMoneyBillWave
                                        size={14}
                                        className="text-green-600"
                                      />
                                      {formatToReal(query?.price || 0)}
                                    </span>
                                  </Table.Cell>
                                )}

                                {/* Nome do usuário */}
                                <Table.Cell
                                  className="text-center py-2 px-4 max-w-[180px] truncate"
                                  title={query.userName}
                                >
                                  <span className="font-medium">
                                    {query.userName}
                                  </span>
                                </Table.Cell>

                                {/* Sucesso ou falha */}
                                <Table.Cell className="text-center py-2 px-4">
                                  <Badge
                                    color={query.isSuccess ? "green" : "red"}
                                    className="w-fit mx-auto text-xs px-2 py-1 rounded-md"
                                  >
                                    {query.isSuccess ? "Sucesso" : "Falha"}
                                  </Badge>
                                </Table.Cell>

                                {/* Ações */}
                                <Table.Cell className="text-center py-2 px-4">
                                  <div className="flex items-center justify-center gap-2">
                                    {query?.isSuccess ? (
                                      <>
                                        <Tooltip
                                          id="tooltip-view"
                                          content="Visualizar consulta"
                                        />
                                        <MdOutlinePageview
                                          data-tooltip-id="tooltip-view"
                                          className="text-blue-800 hover:text-blue-800 transition cursor-pointer"
                                          fontSize={25}
                                          onClick={() => {
                                            setSelectedQueryReview(query);
                                            setDataQuery(query.data);
                                            setOpenModal(true);
                                          }}
                                        />
                                      </>
                                    ) : null}
                                  </div>
                                </Table.Cell>
                              </Table.Row>
                            ))
                          ) : (
                            <Table.Row>
                              <Table.Cell
                                colSpan={6}
                                className="text-center py-6 text-gray-500"
                              >
                                Nenhuma consulta encontrada neste período.
                              </Table.Cell>
                            </Table.Row>
                          )}
                        </>
                      ) : (
                        <TableLoading cols={6} />
                      )}
                    </Table.Body>
                  </Table>
                </div>
              ) : (
                <EmptyTable icon="search_off">
                  Nenhum registro encontrado com esses filtros
                </EmptyTable>
              )}
            </>
          ) : (
            <>
              {listReportSimplifiedQueries?.length > 0 ||
              isLoadingReportSimplifiedQueries ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 bg-white p-4 rounded-2xl border border-gray-200 shadow-sm">
                  {listReportSimplifiedQueries?.map((query, index) => (
                    <div
                      key={index}
                      className="flex flex-col justify-between gap-3 p-4 rounded-2xl border border-gray-100 bg-gradient-to-b from-white to-gray-50 shadow transition hover:shadow-md"
                    >
                      {/* Nome da Consulta */}
                      <div className="flex items-start gap-2">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center text-xs font-bold uppercase shadow-sm">
                          {query.queryName?.[0]}
                        </div>
                        <div className="min-w-0">
                          <p
                            className="text-sm font-semibold text-gray-800 truncate"
                            title={query.queryName}
                          >
                            {query.queryName}
                          </p>
                          <p className="text-[11px] text-gray-500">Consulta</p>
                        </div>
                      </div>

                      {/* Divider */}
                      <div className="border-t border-dashed border-gray-200 my-1.5" />

                      {/* Info quantitativa */}
                      <div className="flex items-end justify-between text-sm">
                        <div className="flex flex-col text-left">
                          <span className="text-blue-700 font-bold">
                            {query.count}
                          </span>
                          <span className="text-[11px] text-gray-500">
                            Qtd. Total
                          </span>
                        </div>
                        <div className="flex flex-col text-right">
                          <span className="text-green-700 font-bold">
                            {formatToReal(query?.totalPrice || 0)}
                          </span>
                          <span className="text-[11px] text-gray-500">
                            Valor
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <EmptyTable icon="search_off">
                  Nenhum registro encontrado com esses filtros
                </EmptyTable>
              )}
            </>
          )}

          {totalPages > 1 && (
            <div className="flex overflow-x-auto justify-center mt-3">
              <Pagination
                layout="pagination"
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
                previousLabel=""
                nextLabel=""
                showIcons
              />
            </div>
          )}
        </div>
        <Modal show={openModal} onClose={() => setOpenModal(false)} size="4xl">
          <ModalHeader>Visualizar consulta</ModalHeader>
          <ModalBody className="bg-gray-100">
            {!isOlderThan30Days(selectedQueryReview?.createdAt) ? (
              <>
                <div className="review-query" ref={printRef}>
                  {selectedQueryReview?.categoryId === 1 && (
                    <CustomCreditQueryReview
                      dataFromLocalStorage={dataQuery}
                      query={selectedQueryReview}
                    />
                  )}
                  {selectedQueryReview?.categoryId === 2 && (
                    <CustomCadastralQueryReview
                      dataFromLocalStorage={dataQuery}
                      query={selectedQueryReview}
                    />
                  )}
                  {selectedQueryReview?.categoryId === 3 && (
                    <CustomVehicleQueryReview
                      dataFromLocalStorage={dataQuery}
                      query={selectedQueryReview}
                    />
                  )}
                </div>
              </>
            ) : (
              <div className="bg-gray-50 p-2 rounded-md border border-gray-300 rounded-md">
                A consulta não está mais disponível para visualização em nossa
                base de dados, possivelmente por ter ultrapassado o período de
                retenção (7 dias) ou por políticas de conformidade. Se precisar
                reavaliar, recomendamos gerar uma nova consulta.
              </div>
            )}
          </ModalBody>
          <ModalFooter className="flex justify-center">
            <Button onClick={() => reactToPrintFn()}>Imprimir</Button>
            <Button color="gray" onClick={() => setOpenModal(false)}>
              Fechar
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default ReportTable;
